import { z } from "zod";

export const REFERRAL_REWARD_PERCENT = 20;
export const REFERRAL_MAX_CREDITS_PER_REFERRAL = 10_000;

export const ReferralCreditIncreaseDto = z.object({
  externalId: z.string(),
  createdAt: z.string(),
  credits: z.number(),
});

export const ReferralOverviewDto = z.object({
  referralCode: z.string(),
  creditIncreases: z.array(ReferralCreditIncreaseDto),
});

export const MarketingSiteReferrerDetailsDto = z.object({
  referrerFirstName: z.string(),
});

export type ReferralOverviewDto = z.infer<typeof ReferralOverviewDto>;
export type ReferralCreditIncreaseDto = z.infer<
  typeof ReferralCreditIncreaseDto
>;
export type MarketingSiteReferrerDetailsDto = z.infer<
  typeof MarketingSiteReferrerDetailsDto
>;
